import type { ExaminationStatistics } from 'src/types/examination';

import useSWR from 'swr';

import { fetcher, endpoints } from 'src/lib/axios';

import { ExaminationStatisticsSchema } from 'src/types/examination';

export function useExaminationStatistics(lessonId?: number, todoId?: number) {
  const { data, error, isLoading, mutate } = useSWR<ExaminationStatistics>(
    lessonId && todoId ? ['statistics', lessonId, todoId] : null,
    async () => {
      const rawData = await fetcher(
        endpoints.examination.statisticsByLessonAndTodo(lessonId!, todoId!)
      );
      return ExaminationStatisticsSchema.parse(rawData);
    }
  );

  return {
    statistics: data,
    isLoading: lessonId && todoId ? isLoading : false,
    error: !lessonId || !todoId ? new Error('Missing required parameters') : error,
    refetch: mutate,
    hasRequiredParams: !!(lessonId && todoId),
  };
}
